<div class="onboarding-page-container">
  <!-- <button id="closeDialog" (click)="closeDialog()">
      <img src="../assets/images/x_circle_icon.svg" alt="" />
    </button> -->

  <!-- Policy Header -->
  <!-- <div id="policy-detail-header">
     
      
      <mat-divider></mat-divider>
    </div>  -->

  @if (!loading) {
  <div class="main-container">
    <div id="policy-detail-header">

      <h1>Policy Code: <strong>{{this.data.policyCode}}</strong></h1>

      <mat-divider></mat-divider>
    </div>

    @for (doc of documentsDiary$ | orderBy : 'sequence' : 'asc'; track doc.diary.id) {
    <div class="policy-document-container">
      <div class="policy-document-box">
        <div class="policy-document-header" [ngClass]="
              doc.diary.id === expandedControl ? 'expanded' : 'collapsed'
            " (click)="expand(doc)">
          <div class="document-title">
            {{ doc.title }}

            @if (doc.isSubmitted) {
            <img id="uploaded-icon" src="../../../../assets/images/check-confirmation.svg" width="40px" alt="" />
            }
          </div>
          <div class="document-info">
            @if (!doc.isSubmitted) {
            <div id="info-icon" class="info-icon-mask"></div>
            <label id="info">{{ doc.info }}</label>
            }
          </div>
          <div class="arrow">
            <span class="material-symbols-outlined">
              {{
              doc.diary.id === expandedControl ? "expand_less" : "expand_more"
              }}
            </span>
          </div>
        </div>
        <div class="policy-document-content" [ngClass]="{
              show: doc.diary.id === expandedControl,
              hide: doc.diary.id !== expandedControl
            }">
          <div class="content-body" [id]="doc.diary.id">
            @if (doc.errorMessage) {
            <div class="error-message">
              {{ doc.errorMessage }}
              <button (click)="errorMessageClosed(doc)">
                <span class="material-symbols-outlined"> close </span>
              </button>
            </div>
            }
            @if (doc.name === 'iban') {
            <app-iban-capture [document]="doc" [progress]="doc.uploadProgress"
              (onSubmitted)="submitTextDocument($event)"
              (onErrorMessageClosed)="errorMessageClosed($event)"></app-iban-capture>
            }
            @else if (doc.name === 'gapInCover') {
            <app-gap-in-cover-capture [document]="doc" [progress]="doc.uploadProgress"
              (onChanged)="onMultiTextDocumentChange($event)" (onSubmitted)="submitTextDocument($event)"
              (onErrorMessageClosed)="errorMessageClosed($event)"></app-gap-in-cover-capture>
            }
            @else if (doc.name === 'irishRegistration') {
            <app-irish-registration-capture [document]="doc" [progress]="doc.uploadProgress"
              (onChanged)="onTextDocumentChange($event)" (onSubmitted)="submitTextDocument($event)"
              (onErrorMessageClosed)="errorMessageClosed($event)"></app-irish-registration-capture>
            }
            @else if (doc.name === 'ncbTransferDeclaration') {
            <app-ncb-transfer-declaration [document]="doc" [progress]="doc.uploadProgress"
              (onChanged)="onTextDocumentChange($event)" (onSubmitted)="submitTextDocument($event)"
              (onErrorMessageClosed)="errorMessageClosed($event)"></app-ncb-transfer-declaration>
            }
            @else if (doc.name === 'creditWorthinessCheck') {
            <app-credit-worthiness-check-capture [document]="doc" [progress]="doc.uploadProgress"
              (onFileCleaned)="onFileCleaned($event)" (onFileUploaded)="onFileUploaded($event)"
              (onSubmitted)="submitDocument($event)"
              (onErrorMessageClosed)="errorMessageClosed($event)"></app-credit-worthiness-check-capture>
            }
            @else if (doc.name === 'tppEjourneyDiary') {
            <app-tpp-ejourney [document]="doc" [progress]="doc.uploadProgress"
              (onSubmitted)="submitTextDocument($event)"
              (onErrorMessageClosed)="errorMessageClosed($event)"></app-tpp-ejourney>
            }
            @else if (doc.name === 'digitalJourney' || doc.name === 'premiumCreditEJourney') {
            <span>Your finance provider has sent you an email and text message, please follow the link included to
              complete your finance application.</span>
            }
            @else if (doc.type === 'file') {
            @if (doc.isSubmitted === false) {
            <app-generic-document-capture [document]="doc" (onFileUploaded)="onFileUploaded($event)"
              (onCleaned)="onFileCleaned($event)" (onSubmitted)="submitDocument($event)"></app-generic-document-capture>
            }
            @if (doc.isSubmitted === true) {
            <app-upload-confirmation></app-upload-confirmation>
            }
            }
          </div>
        </div>
      </div>
      <div class="progress-container">
        @if (doc.uploadProgress > 0 && doc.isSubmitted === false) {
        <mat-progress-bar class="example-margin" color="red" [mode]="'determinate'" [value]="doc.uploadProgress"
          [bufferValue]="25">
        </mat-progress-bar><span>{{ doc.uploadProgress }}%</span>
        }
      </div>
    </div>
    }


  </div>

  }
  <div class="spinner-container">
    @if (loading) {
    <mat-spinner></mat-spinner>
    }
  </div>
</div>